import DatabaseModel from './DatabaseModel.js';

// #975 · Evaluación del tutor (A.04.01.PG-05) de las personas en formación de una inspección.
// Vive en el módulo de Formación de la API (colección form_practica_tutor), no en el expediente:
// por eso no pasa por el guardado del formulario de inspección.
const PracticaTutor = Object.create(DatabaseModel);

PracticaTutor.model = 'api/formacion/practicas-tutor';

PracticaTutor.url = function(ruta) {
    return this.server_movilidad + this.prefix + this.model + ruta;
};

PracticaTutor.deExpediente = function(expedienteId) {
    return this.sendRequest({
        url: this.url('/expediente/' + encodeURIComponent(expedienteId)),
        method: 'GET'
    }, false);
};

// Tutor y firma no viajan: los pone la API con la sesión.
PracticaTutor.guardar = function(expedienteId, username, datos, firmar) {
    const ruta = '/expediente/' + encodeURIComponent(expedienteId)
        + '/persona/' + encodeURIComponent(username) + (firmar ? '/firmar' : '');
    return this.sendRequest({
        url: this.url(ruta),
        method: firmar ? 'POST' : 'PUT',
        data: datos
    }, false);
};

export default PracticaTutor;
